import bgMobile from "../../images/bgMobileGreen.svg";
import bgGreenOval from "../../images/bgDeskGreen.svg";
import bgAnimals from "../../images/bgAnimals.png";
import cow from "../../images/cow.png";
import chicken from "../../images/chicken.png";
import esel2 from "../../images/esel2.png";
import rueben from "../../images/rueben.png";
import sheep from "../../images/sheeps.png";
import goose from "../../images/goose.png";

const Data = {
  header: {
    heading: "Unsere Tiere",
    text: "Unsere Tiere lieben Kinder. Mit ihren freundlichen Gemüt lassen sie sich gerne streicheln. Unsere Tiere haben genug Zeit zur Entspannung und freuen sich immer über nette Besucher.",
    bgMobile: bgMobile,
    bgMobileAlt: "Hindergrundbild Mobile",
    bgDesktop: bgGreenOval,
    bgDesktopAlt: "Hintrgrundbild Desktop",
    imgSrc: bgAnimals,
    imgAlt: "Tiere",
    scrollToText: "Jetzt entdecken",
    scrollTo: "willkommen",
  },
  teaserMain: {
    heading: "Unsere Tiere",
    text: 'Erlebniswelt Bauernhof ist gegründet worden um: den Kindern direkt vor Ort die Natur nahezubringen, um Ihnen ein Gefühl für die Schönheit der "Schöpfung" zu vermitteln und die Welt auch noch für nachkommende Generationen in diesem Umfang zu erhalten.',
  },
  teaserSec: {
    card1: {
      heading: "Hühner",
      text: "Gemischte Hühnerrassen, die braune, weiße und grüne Eier legen, laufen bei uns frei auf dem Hof herum. Die Seidenhühner, die ganz besonders schön anzusehen sind, geben kleine Eier. Eier können bei uns auf dem Hof gekauft werden.",
      imgSrc: chicken,
      imgAlt: "Hühner",
    },
    card2: {
      heading: "Kühe",
      text: "Unsere Kälber wachsen noch ganz ursprünglich bei ihren Müttern auf. Den ganzen Sommer über sind sie auf der Wiese und lassen sich gerne mit Brot und Möhren füttern. Unsere Rassen sind Fleckvieh, Charolai und die bayerische Milchkuh.",
      imgSrc: cow,
      imgAlt: "Kühe",
    },
  },
  teaserThird: {
    card3: {
      imgSrc: esel2,
      imgAlt: "Esel",
    },
    card4: {
      heading: "Esel",
      text: "Pedro, Shelty, Mona, Teresa und Samson sind unsere liebenswürdigen Esel. Sie mögen lange Streicheleinheiten, Putzen oder Striegeln, ihre Mähne zu Zöpfen flechten oder mit Federn verzieren lassen. Außerdem mögen sie Spaziergänge oder geführtes Reiten.",
      imgSrc: rueben,
      imgAlt: "Rüben",
    },
  },
  card5: {
    heading: "Schafe",
    text: "Eine kleine Schafherde von ca. 5 Schafen wohnt ebenfalls auf unserem Hof. Heidschnucken, Coburger Rotfuchs ist ihre Rasse.",
    imgSrc: sheep,
    imgAlt: "Schafe",
  },
  card6: {
    heading: "Gänse",
    text: "Unsere “Wachhunde” die Gänse können Manchem mit ihrem Geschnatter Angst einjagen. Aber lassen sie sich nicht täuschen, ihr Charakter ist freundlich. Und im Frühjahr legen sie leckere Eier und sie freuen sich immer über eine Möhre",
    imgSrc: goose,
    imgAlt: "Gänse",
  },
};

export default Data;
